import ArrowUp from '@assets/icons/arrow-up.svg'
import { Icon } from './Icon'

export const ArrowUpIcon = Icon(ArrowUp)
